import { Box, Button, Card } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useDataProvider, useNotify, useRefresh } from "react-admin";
import { foundSameCount, sortByCount } from "../../helpers/creditsArray";
import { UpdateCreditsGeneralRequest } from "../../types/credits";
import {
  CreditProps,
  CreditsPickerComponent,
} from "../common/generalPickersBlocks/credits/CreditsPickerComponent";
import "./style.css";

export interface CreditError {
  creditId: string;
  count: boolean;
  percent: boolean;
}
export const CreditLayoutTab = () => {
  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useDataProvider();
  const [isActiveCredits, setDoesCreditsActive] = useState<boolean>(false);
  const [stateCredits, setCredits] = useState<Array<CreditProps>>([]);
  const docId = useRef<number | null>(null);
  useEffect(() => {
    setCreditsToState();
  }, []);

  const setCreditsToState = async () => {
    const general = await getGeneral();
    const creditsRates = general.creditsRates.map((i)=>{
      return {
        ...i,
        id: "_" + Math.random().toString(36).substr(2, 9),
      }
    })
    const creditsArr = sortByCount(creditsRates);
    setCredits(creditsArr);
    setDoesCreditsActive(general.isCreditsRates);
    docId.current = general._id;
  };

  const getGeneral = async () => {
    const result = await dataProvider.getGeneral();
    return result.data;
  };

  const handleChangeCreditsStatus = () => {
    setDoesCreditsActive(!isActiveCredits);
  };
  const handleSetCredits = (creditsArr: Array<CreditProps>) => {
    setCredits(creditsArr);
  };

  const handleSaveCredits = async () => {
    const creditsRatesWithoutId = stateCredits.map((i)=>{
      const {id,...rate} = i
      return{
        ...rate
      }
    })
    const dataForRequest: UpdateCreditsGeneralRequest = {
      creditsRates: isActiveCredits? creditsRatesWithoutId: new Array<CreditProps>(),
      isCreditsRates: isActiveCredits,
    };

    if (isActiveCredits && stateCredits.length === 0) {
      notify("At least one credits value must be filled","error");
      return
    }
      const result = await dataProvider.updateGeneral({
        id: docId.current,
        data: dataForRequest,
        previousData: {} as any,
      });

      if (!result.data) {
        notify("something went wrong", "error");
      }
      notify(`Credits successfully update`);
      refresh();
  };
  return (
    <Card component="div" className="tabCardWrapper creditsTabLayout">
      <CreditsPickerComponent
        withSaveBtn={true}
        handleChangeCreditsStatus={handleChangeCreditsStatus}
        handleSetCredits={handleSetCredits}
        isActiveCredits={isActiveCredits}
        credits={stateCredits}
        handleSaveCredits={handleSaveCredits}
      />
    </Card>
  );
};
